var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "抽奖详情",
        width: "696px",
        loading: _vm.loading,
        height: "auto",
        top: _vm.top,
      },
      on: { success: _vm.sure },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        { staticClass: "addLottery overflowOuto" },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "form",
              attrs: {
                model: _vm.form,
                "label-width": "auto",
                size: "small",
                rules: _vm.rules,
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "抽奖名称", prop: "prizeDrawName" } },
                [_vm._v(" " + _vm._s(_vm.form.prizeDrawName) + " ")]
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: "参与条件", prop: "participationCondition" },
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        { 1: "用户在线", 2: "参与任意评论", 3: "参与指定评论" }[
                          _vm.form.participationCondition
                        ]
                      )
                    ),
                  ]),
                  _vm.form.participationCondition === 3
                    ? _c("el-input", {
                        staticClass: "m-t-10",
                        attrs: {
                          disabled: "",
                          placeholder: "点击输入指定的评论",
                          maxlength: "50",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.form.assignedComment,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "assignedComment",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.assignedComment",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "奖品设置", prop: "prizeDetail" } },
                [
                  _vm.form.prizeDetail.length > 0
                    ? _c(
                        "el-table",
                        {
                          ref: "elTable",
                          staticClass: "myLotteryTable m-t-10",
                          staticStyle: { width: "547px" },
                          attrs: {
                            border: "",
                            data: _vm.form.prizeDetail,
                            "cell-class-name": "cursorMove",
                            "header-cell-style": { background: "#F3F3F3" },
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { type: "index", width: "32" },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "goodsName",
                              label: "奖品",
                              "min-width": "184",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "prizeType",
                              label: "类型",
                              width: "72",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            {
                                              1: "虚拟商品",
                                              2: "实物商品",
                                              3: "优惠券",
                                            }[row.prizeType]
                                          ) +
                                          " "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1625438923
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "prizeName",
                              label: "奖品名称",
                              width: "130",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "amount",
                              label: "份数",
                              width: "74",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: "规则设置", prop: "showParticipantsAmount" },
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { disabled: "" },
                      model: {
                        value: _vm.form.showParticipantsAmount,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "showParticipantsAmount", $$v)
                        },
                        expression: "form.showParticipantsAmount",
                      },
                    },
                    [_vm._v("用户端将展示抽奖参与人数")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "抽奖说明", prop: "prizeInstructions" } },
                [_vm._v(" " + _vm._s(_vm.form.prizeInstructions) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }),
      _c("selectGift", {
        attrs: { config: _vm.selectGiftConfig },
        on: { success: _vm.onhandleSelect },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }